// extracted by mini-css-extract-plugin
export default {"divider":"style_divider__Ky9aC"};